import {Form} from '../../../../stores/Form';

export const getTotal = (form: Form) => {
    const {allRecordsCount, searchModeLevel, records, currentRecord} = form;
    if (searchModeLevel > 0) {
        return records.length;
    }

    return currentRecord.isNew ? allRecordsCount + 1 : allRecordsCount;
};
